import React from 'react';
import { scrollToPurchase } from '../utils/checkout';
export function HeroSection() {
  return <section className="bg-gradient-to-b from-[#2A1D10] via-[#3B2A1A] to-[#4A3525] pt-6 pb-10 px-4" data-id="element-144">
      <div className="max-w-3xl mx-auto text-center" data-id="element-145">
        {/* Pre-headline */}
        <p className="font-sans font-medium text-amber-300/80 uppercase tracking-wider text-[11px] md:text-xs mb-5" data-id="element-146">
          For dog owners who want beautiful photos without expensive gear
        </p>

        {/* Main Headline */}
        <h1 className="font-serif text-3xl md:text-5xl lg:text-[3.4rem] font-bold text-white mb-4 leading-[1.15]" data-id="element-147">
          The <span className="italic text-soft-gold" data-id="element-148">Pawfect</span> Shot
          MegaPack
        </h1>

        {/* Subheadline */}
        <p className="font-sans text-base md:text-lg text-amber-100/85 mb-6 max-w-2xl mx-auto leading-relaxed" data-id="element-149">
          A simple, beginner-friendly system for taking beautiful photos of your
          dog with just your phone
        </p>

        {/* Hero Mockup Image — DO NOT CHANGE THIS URL */}
        <a href="#purchase" onClick={scrollToPurchase} className="block mb-5 cursor-pointer group" data-id="element-150">
          <img src="https://cdn.magicpatterns.com/uploads/3PT8RfiEcKK1SiRHns82tF/ChatGPT_Image_Mar_20,_2026,_10_20_45_AM.png" alt="The Pawfect Shot MegaPack — 6 complete guides for stunning dog photography with your phone" className="w-full max-w-xl mx-auto rounded-lg shadow-2xl transition-transform duration-300 group-hover:scale-[1.02]" fetchPriority="high" width={576} height={576} data-id="element-151" />
        </a>

        {/* Bullets */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-5 mb-6" data-id="element-152">
          <span className="font-sans text-sm text-amber-100/90 flex items-center gap-1.5" data-id="element-153">
            <span className="text-green-400" data-id="element-154">✅</span> No professional camera
            needed
          </span>
          <span className="font-sans text-sm text-amber-100/90 flex items-center gap-1.5" data-id="element-155">
            <span className="text-green-400" data-id="element-156">✅</span> No confusing photography
            jargon
          </span>
          <span className="font-sans text-sm text-amber-100/90 flex items-center gap-1.5" data-id="element-157">
            <span className="text-green-400" data-id="element-158">✅</span> No more random,
            disappointing results
          </span>
        </div>

        {/* Text below image */}
        <p className="font-sans text-base md:text-lg text-amber-100/80 mb-6 max-w-2xl mx-auto leading-relaxed" data-id="element-159">
          Everything you need to take better dog photos with the phone you
          already own — without expensive gear, technical overwhelm, or
          guesswork.
        </p>

        {/* CTA Button */}
        <button onClick={scrollToPurchase} className="w-full md:w-auto bg-green-600 hover:bg-green-700 text-white font-sans font-bold text-base md:text-lg py-4 px-10 rounded-full shadow-cta transition-all duration-300 transform hover:-translate-y-1 uppercase text-center" data-id="element-160">
          👉 Get Instant Access to The Pawfect Shot MegaPack
        </button>

        {/* Microcopy */}
        <p className="font-sans text-sm text-amber-200/60 mt-3" data-id="element-161">
          Includes 6 complete guides + 3 free bonuses + 7-day guarantee
        </p>
      </div>
    </section>;
}